module.exports = __webpack_public_path__ + "static/body-117e58e9fc9ff1bd5974d66ae32cb1f5.png";